import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: (resolve) => require(['../components/index/index.vue'], resolve)
        },
        {
            path: '/special',
            name: 'special',
            component: (resolve) => require(['../components/special/special.vue'], resolve)
        },
        {
            path: '/green',
            name: 'green',
            component: (resolve) => require(['../components/green/green.vue'], resolve)
        },
        {
            path: '/help',
            name: 'help',
            component: (resolve) => require(['../components/help/help.vue'], resolve)
        },
        {
            path: '/recruit',
            name: 'recruit',
            component: (resolve) => require(['../components/recruit/recruit.vue'], resolve)
        },
        {
            path: '/about',
            name: 'about',
            component: (resolve) => require(['../components/about/about.vue'], resolve)
        },
        {
            path: '/passenger',
            name: 'passenger',
            component: (resolve) => require(['../components/index/passenger.vue'], resolve)
        },
        {
            path: '/driver',
            name: 'driver',
            component: (resolve) => require(['../components/index/driver.vue'], resolve)
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js